const InitiativePlanningSummary = (initiative) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Cancelled overrides everything
  if (initiative.weeklyStatus === 'Cancelled') {
    return { planningStatus: 'Cancelled' };
  }

  // L5 is always realized
  if (initiative.stage === 'L5') {
    return { planningStatus: 'Realized' };
  }

  const nextStageMap = {
    L0: 'L1',
    L1: 'L2',
    L2: 'L3',
    L3: 'L4',
    L4: 'L5',
  };

  const nextStage = nextStageMap[initiative.stage];

  if (!nextStage) {
    return { planningStatus: '<not set>' };
  }

  const nextStageEntry = initiative.timeline?.find(
    (entry) => entry.stage === nextStage && entry.date?.plan
  );

  if (!nextStageEntry) {
    return { planningStatus: `Not planned (${nextStage})` };
  }

  const planDate = new Date(nextStageEntry.date.plan);
  planDate.setHours(0, 0, 0, 0);

  if (isNaN(planDate.getTime())) {
    return { planningStatus: `Not planned (${nextStage})` };
  }

  // ✅ correct day difference
  const diffInDays = Math.floor(
    (planDate - today) / (1000 * 60 * 60 * 24)
  );

  // Past due
  if (diffInDays < 0) {
    return { planningStatus: `Past due for ${nextStage}` };
  }
  
  // ✅ Priority: Due soon (7 days) first
  if (diffInDays <= 7) {
    return { planningStatus: `Due soon for ${nextStage}` };
  }
  
  // Then check for 30 days (this will catch days 8–30)
  if (diffInDays <= 30) {
    return { planningStatus: `Due soon for ${nextStage} for 30 days` };
  }

  return { planningStatus: 'On plan' };
};

export default InitiativePlanningSummary;